import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { type FusionMachine } from "@packsize/schemas/machines";

import { getFusionMachines } from "@/api/machines/fusion-api-v2";

import { type UseMachinesQueryOptions } from "../types";

import { FUSION_MACHINES_QUERY_KEY } from "./query-keys";

const REFETCH_INTERVAL = 15 * 1000;

export const getFusionMachinesQuery = <TData = FusionMachine[], TError = Error>(
	options?: UseMachinesQueryOptions<TData, TError>,
) => ({
	queryKey: FUSION_MACHINES_QUERY_KEY,
	queryFn: getFusionMachines,
	refetchInterval: REFETCH_INTERVAL,
	staleTime: 10 * 1000,
	...options,
});

export const useFusionMachines = (
	options?: UseMachinesQueryOptions<FusionMachine[], Error>,
): UseQueryResult<FusionMachine[], Error> => {
	return useQuery<FusionMachine[], Error>(getFusionMachinesQuery(options));
};
